import * as z from 'zod';

const optionalSymbol = z
  .string()
  .trim()
  .toUpperCase()
  .refine(
    (value) => !value || /^[A-Z0-9][A-Z0-9._-]{0,31}$/.test(value),
    'Enter a symbol such as USDT or BEP20 (up to 32 characters).'
  )
  .optional();

export const paymentReportFiltersSchema = z.object({
  playerIds: z.array(z.string()).optional(),
  partnerIds: z.array(z.string()).optional(),
  type: z.string().nullish(),
  status: z.string().nullish(),
  paymentMethod: z.string().nullish(),
  cryptoProvider: z.enum(['', 'moralis', 'zero_x_processing']).nullish(),
  cryptoAsset: optionalSymbol,
  cryptoNetwork: optionalSymbol,
});

export type PaymentReportFilters = z.infer<typeof paymentReportFiltersSchema>;
